module.exports = __webpack_public_path__ + "img/_create_chat.b3186e24.svg";